import React from 'react';
import classNames from 'classnames';
import Lottie from 'react-lottie';
import utils from '@gjensidige/core-utilities-css';
import { Col, Container, Row } from '@gjensidige/nci-core-grid';

import styles from './assets/styles/layout.module.scss';
import * as animation from './assets/svg/builders-logo-animation.json';

interface LayoutProps {
  children: React.ReactNode;
  page?: string;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className={styles.overrides}>
      <Container>
        <Row
          className={classNames(styles.rowMain, utils['align-items-md-center'])}
        >
          <Col
            xs="12"
            md="4"
            className={classNames(
              utils['d-flex'],
              utils['justify-content-center'],
              utils['d-md-block']
            )}
          >
            <div className={styles.buildersIcon}>
              <Lottie
                options={{
                  loop: false,
                  autoplay: true,
                  animationData: animation,
                  rendererSettings: {
                    preserveAspectRatio: 'xMidYMid slice'
                  }
                }}
                // height={400}
                // width={400}
              />
            </div>
          </Col>
          <Col xs="12" md="8">
            {children}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Layout;
